export function someMutation(/* state */) {}

export function storeDegrees(state, data) {
  state.degrees = data;
}

export function storeProjects(state, data) {
  state.projects = data;
}

export function storeFaculties(state, data) {
  state.faculties = data;
}

export function storeDepartments(state, data) {
  state.departments = data;
}

export function storePrefixes(state, data) {
  state.prefixes = data;
}

export function storeCurriculums(state, data) {
  state.curriculums = data;
}

export function storeAssessments(state, data) {
  state.assessments = data;
}

export function storeSubjectGroups(state, data) {
  state.subjectGroups = data;
}

export function storeSubjects(state, data) {
  state.subjects = data;
}
